const productEntryFragment = `
	fragment productEntryFragment on swatches_Entry {
		id
		title
		uri
		url
		imageJpg1x: swatchImage {
			id
			url @imagerTransform(width:414, height:333, mode:"crop", format: "jpg")
		}
		imageJpg2x: swatchImage {
			id
			url @imagerTransform(width:828, height:666, mode:"crop", format: "jpg")
		}
    product {
      id
      title
    }
    colourRange {
			id
			title
		}
    colour {
			id
			title
		}
		texture {
			id
			title
		}
    finish {
			id
			title
		}
	}
`;

// imageWebp1x: swatchImage {
// 	id
// 	url @imagerTransform(width:414, height:333, mode:"crop", format: "webp")
// }
// imageWebp2x: swatchImage {
// 	id
// 	url @imagerTransform(width:828, height:666, mode:"crop", format: "webp")
// }

const productEntries =
	`
	query ($offset: Int, $limit: Int, $productType: [QueryArgument], $relations: [QueryArgument], $term: String) {
		entries(
			section: "swatches"
			offset: $offset
			limit: $limit
      product: $productType
			relatedTo: $relations
			search: $term
		) {
			...productEntryFragment
		}
	}
` + productEntryFragment;

const productCategories = `
	query productCategories {
    productType: entries(section: "products") { 
			id
			title
			parent {
				title
			}
		}
    colourRange: categories(group: "swatchesColourRange") {
			id
			title
		}
		colour: categories(group: "swatchesColour") {
			id
			title
		}
		finish: categories(group: "swatchesFinish") {
			id
			title
		}
		texture: categories(group: "swatchesTexture") {
			id
			title
		}
	}
`;

const productShortlist =
	`
	query productShortlist($ids: [QueryArgument]) {
		entries(section: "swatches", id: $ids) {
			...productEntryFragment
		}
	}
` + productEntryFragment;

export { productEntries, productCategories, productShortlist };
